module.exports = __webpack_public_path__ + "img/2.c2855c69.png";